import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import UpperHeader from '../../components/header/UpperHeader';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import NewsPiece from '../../components/news_piece/NewsPiece';
import Title from '../../components/title/Title';

type NewsData = {
    title: string;
    date: string;
    control: number;
    content: string;
    pictureSrc: string;
    pictureAlt: string;
    topBar: boolean;
    id?: string;
    linkUrl?: string;
    linkLabel?: string;
};

const News: React.FC = () => {
    const [newsData, setNewsData] = useState<NewsData[]>([]);
    const location = useLocation();

    // 先頭の # を除いた識別子。/activity/news#〇〇 で個別記事を開く
    const targetId = location.hash.replace(/^#/, '');

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/newsData.json`)
            .then(response => response.json())
            .then(data => setNewsData(data));
    }, []);

    // 記事の描画が終わってから該当箇所までスクロールする
    useEffect(() => {
        if (!targetId || newsData.length === 0) return;

        const element = document.getElementById(targetId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [targetId, newsData]);

    return (
        <div>
            <UpperHeader />
            <Header pageTitle='ニュース' />
             <Title text='ニュース'></Title>
            {newsData.map((news, index) => (
                <NewsPiece
                    key={news.id ?? index}
                    title={news.title}
                    date={news.date}
                    control={news.control}
                    content={news.content}
                    pictureSrc={news.pictureSrc}
                    pictureAlt={news.pictureAlt}
                    topBar={news.topBar}
                    anchorId={news.id}
                    defaultOpen={Boolean(news.id) && news.id === targetId}
                    linkUrl={news.linkUrl}
                    linkLabel={news.linkLabel}
                />
            ))}
            <Footer />
        </div>
    );
}

export default News;
